import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";
import { PersonRemoveOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { unassignServiceResponse, unassignWorkerServiceAction } from "../../../../store/reducers/clientConfirmationSlice";
const ServiceConfirmation = ({
  error,
  formData,
  setFormData,
  setError,
  isDisabled,
  setIsDoorToDoorAccept,
  setIsFullPackAccept,
  setAnyChangeFieldValue,
}: {
  error: any;
  formData: any;
  setFormData: any;
  setError: any;
  isDisabled: any;
  setIsDoorToDoorAccept: any;
  setIsFullPackAccept: any;
  setAnyChangeFieldValue: any;
}) => {
  const dispatch = useDispatch();
  const {isUnassignWorkerResponse}= useSelector((state: any) => state.confirmation);
  const [showDeclineConfirm, setShowDeclineConfirm] = useState(false);
  const [pendingServiceIndex, setPendingServiceIndex] = useState<number | null>(
    null,
  );
  const [unassignModalOpen, setUnassignModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<any>(null);

  const applyServiceStatus = (index: number, value: string) => {
    const updatedServices = formData.services.map(
      (service: any, idx: number) =>
        idx === index ? { ...service, status: value } : service,
    );

    const doorTodoor: any = updatedServices?.find(
      (ele: any) =>
        ele?.name?.toLowerCase() === "removal" ||
        ele?.type?.toLowerCase() === "removal",
    );
    const fullPack: any = updatedServices?.find(
      (ele: any) =>
        ele?.name?.toLowerCase() === "full pack" ||
        ele?.type?.toLowerCase() === "fullpack",
    );

    if (doorTodoor) {
      setIsDoorToDoorAccept(doorTodoor?.status !== "accept");
      setError({
        ...error,
        movingDate: null,
      });
    }
    if (fullPack) {
      setIsFullPackAccept(fullPack?.status !== "accept");
      setError({
        ...error,
        packingDate: null,
      });
    }

    setFormData({
      ...formData,
      services: updatedServices,
      movingDate: {
        ...formData?.movingDate,
        status:
          doorTodoor &&
          doorTodoor?.status !== "accept" &&
          doorTodoor?.status !== null
            ? "awaiting"
            : formData?.movingDate?.status,
      },
      packingDate: {
        ...formData?.packingDate,
        status:
          fullPack && fullPack?.status !== "accept" && fullPack?.status !== null
            ? "awaiting"
            : formData?.packingDate?.status,
      },
    });

    setAnyChangeFieldValue(true);
  };

  const handleServiceChange = (index: number, value: string) => {
    if (value === "decline") {
      setPendingServiceIndex(index);
      setShowDeclineConfirm(true);
      return;
    }

    applyServiceStatus(index, value);
  };

  const confirmDecline = () => {
    if (pendingServiceIndex !== null) {
      applyServiceStatus(pendingServiceIndex, "decline");
    }
    setPendingServiceIndex(null);
    setShowDeclineConfirm(false);
  };

  const cancelDecline = () => {
    setPendingServiceIndex(null);
    setShowDeclineConfirm(false);
    setUnassignModalOpen(false);
    setSelectedService(null);
  };

  useEffect(()=>{
    if(isUnassignWorkerResponse){
      cancelDecline();
      dispatch(unassignServiceResponse(false));
    }
  },[isUnassignWorkerResponse])

  const handleUnassignClick = (field: any, idx: number) => {
    setSelectedService({
      ...field,
      index: idx,
    });

    setUnassignModalOpen(true);
  };

  const handleConfirmUnassign = async () => {
    if (!selectedService) return;
    dispatch(
      unassignWorkerServiceAction({
        confirmationId: formData?.confirmationId,
        serviceId: selectedService?.serviceId,
      }),
    );
  };

  const statusOptions = [
    { value: "accept", label: "Confirmed" },
    { value: "decline", label: "Not Taking" },
  ];

  return (
    <>
      <Grid container spacing={2} rowGap={0} rowSpacing={0}>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "16px 6px 6px 6px !important", display: "flex" }}
        >
          <Typography
            sx={{ fontWeight: 600, color: "#0F906E", width: "120px" }}
          >
            Services
          </Typography>
          <Typography sx={{ fontWeight: 600, color: "#0F906E" }}>
            Description
          </Typography>
        </Grid>
        {formData &&
          formData?.services?.map((field: any, idx: number) => (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  paddingLeft: "10px !important",
                  paddingTop: "6px !important",
                  paddingBottom: "6px !important",
                  display: "flex",
                  flexDirection: "column",
                  borderTop: "2px solid #CFCFCF",
                  background: "#FFF",
                  minHeight: "100px !important",
                }}
              >
                {/* Row: Service name/cost + Status radios */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Box sx={{ display: "block" }}>
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                      }}
                      shrink
                      htmlFor={field?.id}
                    >
                      {field?.name}
                      <span style={{ color: "red", fontWeight: 500 }}>*</span>
                    </InputLabel>

                    <TextField
                      disabled={true}
                      sx={{
                        marginTop: "0px !important",
                        marginRight: "6px",
                        width: "100px",

                        // marginBottom: "8px !important",
                      }}
                      variant="outlined"
                      value={field?.cost}
                      InputProps={{
                        startAdornment: (
                          <span
                            style={{
                              marginRight: "1px",
                              paddingTop: "1px",
                              fontWeight: 600,
                              fontSize: "14px",
                            }}
                          >
                            £
                          </span>
                        ),
                        sx: {
                          height: "36px",
                          padding: "10px 4px",
                        },
                      }}
                      margin="normal"
                      fullWidth
                      error={
                        !!(error && error.services && error.services[idx]?.cost)
                      }
                      helperText={
                        error?.services && error.services[idx]?.cost
                          ? error.services[idx].cost
                          : ""
                      }
                    />
                  </Box>
                  <RadioGroup
                    row
                    value={field.status || ""}
                    onChange={(e) => handleServiceChange(idx, e.target.value)}
                  >
                    {statusOptions.map((option) => (
                      <FormControlLabel
                        key={option.value}
                        sx={{
                          fontSize: "12px",
                          marginTop: "20px",
                          ".MuiTypography-root": {
                            fontSize: "12px",
                          },
                        }}
                        value={option.value}
                        disabled={isDisabled}
                        control={
                          <Radio
                            sx={{
                              color: error?.services?.[idx]?.status
                                ? "red"
                                : "",
                              transform: "scale(0.8)",
                              "& .MuiSvgIcon-root": { fontSize: 18 },
                            }}
                          />
                        }
                        label={option.label}
                      />
                    ))}
                  </RadioGroup>

                  {/* Unassign Button */}
                  {field?.isWorkerUnassignPossible && (
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<PersonRemoveOutlined />}
                      // disabled={isDisabled}
                      onClick={() => handleUnassignClick(field, idx)}
                      sx={{
                        ml: 1,
                        mt: "18px",
                        minWidth: "110px",
                        height: "32px",
                        borderRadius: "6px",
                        textTransform: "none",
                        fontSize: "12px",
                        fontWeight: 600,
                        borderColor: "#D32F2F",
                        color: "#D32F2F",
                        backgroundColor: "#FFF5F5",
                        cursor: "pointer",
                        "&:hover": {
                          borderColor: "#B71C1C",
                          backgroundColor: "#FFEBEE",
                        },
                      }}
                    >
                      Unassign
                    </Button>
                  )}
                </Box>

                {/* Row: Description, below service name and radio buttons */}
                <TextField
                  disabled={true}
                  sx={{
                    marginTop: "4px !important",
                    marginRight: "6px",
                    width: "auto",
                  }}
                  variant="outlined"
                  value={field?.description || ""}
                  InputProps={{
                    sx: {
                      height: "36px",
                      padding: "10px 2px",
                    },
                  }}
                  margin="normal"
                  fullWidth
                />
              </Grid>
            </>
          ))}
      </Grid>
      {(showDeclineConfirm || unassignModalOpen) && (
        <AlertPopup
          open={showDeclineConfirm || unassignModalOpen}
          title={unassignModalOpen ? "Alert" : "Confirm Not Taking"}
          content={
            unassignModalOpen
              ? "Are you sure you want to unassign workers for this service?"
              : "Are you sure you want to reject the quote?"
          }
          onHide={cancelDecline}
          submitHandler={
            unassignModalOpen ? handleConfirmUnassign : confirmDecline
          }
        />
      )}
    </>
  );
};

export default ServiceConfirmation;
